import React, { useState, useEffect } from "react";
import {
  TextField,
  MenuItem,
  Grid,
  Typography
} from "@material-ui/core";


export default function CreditMonthField(
  {
    fieldConfig,
    currentMetafields,
    hideChannels = false,
    channelDisplayNames,
    setMetafieldsValues,
    innerFieldWidth,
    showFullYearsOnly = false,
  }) {

  const [value, setValue] = useState(null);

  useEffect(() => {
    const min = fieldConfig.min ? fieldConfig.min : 0;
    const externalValue =
      currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric === 0
        ? currentMetafields[0].meta_value_numeric
        : min
      ;
    if (externalValue !== value) {
      setValue(externalValue);
    }
  }, [currentMetafields]);

  useEffect(() => {
    if (value !== null) {
      const min = fieldConfig.min ? fieldConfig.min : 0;
      const externalValue =
        currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric === 0
          ? currentMetafields[0].meta_value_numeric
          : min
        ;
      if (externalValue !== value)
        setMetafieldsValues(currentMetafields, value);
    }
  }, [value]);

  if (!fieldConfig)
    return null;

  const helperText = hideChannels
    ? null
    : (currentMetafields.map((metafield, i) => channelDisplayNames[metafield.channel] + (i < currentMetafields.length - 1 ? ", " : "")));

  const min = fieldConfig.min ? fieldConfig.min : 0;
  const max = fieldConfig.max ? fieldConfig.max : 500;

  if (max <= 36 && !showFullYearsOnly) {
    const monthOptions = [];
    for (let i = fieldConfig.min; i <= max; i++)
      monthOptions.push(<MenuItem key={i} value={i}>{i} Monate</MenuItem>)
    return (
      <Grid item xs={12} md={innerFieldWidth} key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_") + "-wrap"}>
        <TextField
          key={currentMetafields[0].id}
          label={fieldConfig.label}
          helperText={helperText}
          value={value !== null ? value : ""}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onBlur={() => {
            // force rerender to make sure placeholders using the value of this field are updated
            setMetafieldsValues(currentMetafields, value, true);
          }}
          select
          style={{ width: 120 }}
        >
          <MenuItem key={currentMetafields[0].id + "-empty"} value="">-</MenuItem>
          {monthOptions}
        </TextField>
      </Grid>
    );
  }

  const monthOptions = [];
  for (let i = 0; i <= 11; i++)
    monthOptions.push(<MenuItem key={i} value={i}>{i} Monate</MenuItem>)
  const yearOptions = [];
  for (let i = Math.floor(min / 12); i <= Math.floor(max / 12); i++)
    yearOptions.push(<MenuItem key={i} value={i}>{i} Jahre</MenuItem>)

  if (showFullYearsOnly) {
    return (
      <React.Fragment key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_") + "-wrap"}>
        <Grid item xs={12} md={6} >
          <Typography>{fieldConfig.label}</Typography>
          <Typography variant="caption" color="textSecondary">{helperText}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            key={currentMetafields[0].id + "-years"}
            label="Jahre"
            value={value !== null ? Math.floor(value / 12) : 0}
            onChange={(e) => {
              let newValue = parseInt(e.target.value) * 12 + (value % 12);
              if (newValue > max)
                newValue = max;
              if (newValue < min)
                newValue = min;
              setValue(newValue);
            }}
            onBlur={() => {
              // force rerender to make sure placeholders using the value of this field are updated
              setMetafieldsValues(currentMetafields, value, true);
            }}
            select
            style={{ width: 100 }}
          >
            <MenuItem key={currentMetafields[0].id + "-empty"} value="">-</MenuItem>
            {yearOptions}
          </TextField>
        </Grid>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment key={fieldConfig.meta_key + "-" + fieldConfig.channels.join("_") + "-wrap"}>
      <Grid item xs={12} md={4} >
        <Typography>{fieldConfig.label}</Typography>
        <Typography variant="caption" color="textSecondary">{helperText}</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          key={currentMetafields[0].id + "-years"}
          label="Jahre"
          value={value !== null ? Math.floor(value / 12) : 0}
          onChange={(e) => {
            let newValue = parseInt(e.target.value) * 12 + (value % 12);
            if (newValue > max)
              newValue = max;
            if (newValue < min)
              newValue = min;
            setValue(newValue);
          }}
          onBlur={() => {
            // force rerender to make sure placeholders using the value of this field are updated
            setMetafieldsValues(currentMetafields, value, true);
          }}
          select
          style={{ width: 100 }}
        >
          <MenuItem key={currentMetafields[0].id + "-empty"} value="">-</MenuItem>
          {yearOptions}
        </TextField>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          key={currentMetafields[0].id + "-months"}
          label="Monate"
          value={value !== null ? value % 12 : 0}
          onChange={(e) => {
            let newValue = value - (value % 12) + parseInt(e.target.value);
            if (newValue > max)
              newValue = max;
            if (newValue < min)
              newValue = min;
            setValue(newValue);
          }}
          onBlur={() => {
            // force rerender to make sure placeholders using the value of this field are updated
            setMetafieldsValues(currentMetafields, value, true);
          }}
          select
          style={{ width: 120 }}
        >
          <MenuItem key={currentMetafields[0].id + "-empty"} value="">-</MenuItem>
          {monthOptions}
        </TextField>
      </Grid>
    </React.Fragment>
  );
}
